export default [
    {   // [0]
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "From",
        placeholder: "Date",
        class: "font-small-2",
        model: null,
        locale: "es",
        dateFormatOptions: { year: 'numeric', month: '2-digit', day: 'numeric' },
        cols: 6,
        visible: true,
    },
    {   // [1]
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "To",
        placeholder: "Date",
        class: "font-small-2",
        model: null,
        locale: "es",
        dateFormatOptions: { year: 'numeric', month: '2-digit', day: 'numeric' },
        cols: 6,
        visible: true,
    },
    {   // [2]
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "Personal Type",
        options: [
            { value: 0, text: app.$i18n.t("All") },
            { value: 1, text: app.$i18n.t("Employee") },
            { value: 2, text: app.$i18n.t("Driver") },
            { value: 4, text: app.$i18n.t("Stevedore") },
        ],
        model: null,
        cols: 6,
        visible: true,
    },
    {   // [3]
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "Viatic",
        options: [
            { value: 0, text: app.$i18n.t("All") },
            { value: 1, text: app.$i18n.t("Apply") },
            { value: 2, text: app.$i18n.t("Not Apply") },
        ],
        model: null,
        cols: 6,
        visible: true,
    },
    {   // [4]
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "Entity Group",
        options: [],
        model: null,
        cols: 12,
        visible: true,
    },
    {   // [5]
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "Status Personal",
        options: [
            { value: 0, text: app.$i18n.t("All") },
            { value: 1, text: app.$i18n.t("Active") },
            { value: 2, text: app.$i18n.t("Inactive") },
            { value: 3, text: app.$i18n.t("Suspend") },
        ],
        model: null,
        cols: 6,
        visible: true,
    },
    {   // [5]
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "Status Attendance",
        options: [
            { value: 1, text: app.$i18n.t("Active") },
            { value: 0, text: app.$i18n.t("Inactive") }
        ],
        model: null,
        cols: 6,
        visible: true,
    },
];